/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:500;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-backdrop[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:400!important;width:100vw;height:100vh;background-color:#000}"];
export { styles as styles };
